<template>
  <div id="app">
    <header>
      <nav>
        <div v-if="isLoggedIn" class="auth-info">
          <span class="user-name">
            {{ userData.fullName }}
            <span v-if="userData.isAdmin" class="admin-badge">admin</span>
            ({{ userData.email }})
          </span>
          <button @click="logout">Logout</button>
        </div>
      </nav>

    </header>
    <main>
      <div class="nav-links">
          <router-link to="/" v-if="isLoggedIn">Пристрої</router-link>
          <router-link to="/chanels" v-if="isLoggedIn && userData.isAdmin">Канали</router-link>
          <router-link to="/users" v-if="isLoggedIn && userData.isAdmin">Користувачі</router-link>
          <router-link to="/settings" v-if="isLoggedIn && userData.isAdmin">Налаштування</router-link>
      </div>
      <router-view @login-success="onLoginSuccess" />
    </main>
  </div>
</template>

<script>
import { ref, onMounted} from 'vue';
import { useRouter } from 'vue-router';
import api from '@/api';

export default {
  name: 'App',
  setup() {
  const router = useRouter();
  const isLoggedIn = ref(false);
  const userData = ref({ fullName: '', email: '' });

  const checkAuth = async () => {
    try {
      const response = await api.get('/auth/me');
      isLoggedIn.value = true;
      userData.value = response.data.userData;
    } catch (err) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      isLoggedIn.value = false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    isLoggedIn.value = false;
    userData.value = { fullName: '', email: '' };
    router.push('/login'); // Переадресація на сторінку входу
  };

  const onLoginSuccess = (user) => {
    isLoggedIn.value = true;
    userData.value = user;
  };

  onMounted(() => {
    checkAuth();
  });

  return {
    isLoggedIn,
    userData,
    logout,
    onLoginSuccess,
  };
},
};
</script>

<style scoped>
#app {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1em;
}

header {
  background-color: #007bff;
  color: white;
  padding: 1em;
  text-align: center;
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-links {
  display: flex;
  justify-content: center;
  gap: 0.5em;
  margin-bottom: 1em;
  padding: 0.5em 0;
  border-bottom: 2px solid #e0e0e0;
  flex-wrap: wrap;
}

.nav-links a {
  padding: 0.4em 0.8em;
  background-color: #f8f9fa;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  border-radius: 5px;
  border: 1px solid #dee2e6;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 0.9em;
  white-space: nowrap;
}

.nav-links a:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.nav-links a.router-link-active,
.nav-links a.router-link-exact-active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
  font-weight: bold;
}

@media (max-width: 768px) {
  .nav-links {
    gap: 0.3em;
    margin-bottom: 0.5em;
    padding: 0.3em 0;
  }

  .nav-links a {
    padding: 0.35em 0.6em;
    font-size: 0.85em;
    flex: 1 1 auto;
    min-width: 0;
    text-align: center;
  }
}

.auth-info {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.user-name {
  margin-right: 1em;
}

.admin-badge {
  background-color: #ffc107;
  color: #000;
  padding: 0.2em 0.5em;
  border-radius: 3px;
  font-size: 0.8em;
  font-weight: bold;
  margin-left: 0.5em;
  text-transform: uppercase;
}

button {
  background-color: white;
  color: #007bff;
  border: none;
  border-radius: 3px;
  padding: 0.5em 1em;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
  color: white;
}

main {
  padding: 1em;
}
</style>
